import { render, staticRenderFns } from "./ReservationsSeller.vue?vue&type=template&id=46c961f5&"
import script from "./ReservationsSeller.vue?vue&type=script&lang=js&"
export * from "./ReservationsSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports